<template>
    <div class="row input-table">
        <div class="col-lg-11">
            <div class="d-flex input-table-shadow">
                <core-drop-down
                    :items="wagons"
                    noLabel
                    :noneLabel="$t('services.inventory.type')"
                    selectedValue=""
                ></core-drop-down>
                <core-drop-down
                    :items="[]"
                    noLabel
                    :noneLabel="$t('services.inventory.occupation')"
                    selectedValue=""
                ></core-drop-down>
                <core-drop-down
                    :items="[]"
                    noLabel
                    :noneLabel="$t('services.inventory.type')"
                    selectedValue=""
                ></core-drop-down>
                <core-drop-down
                    :items="[]"
                    noLabel
                    :noneLabel="$t('services.inventory.from')"
                    selectedValue=""
                ></core-drop-down>
                <core-drop-down
                    :items="[]"
                    noLabel
                    :noneLabel="$t('services.inventory.to')"
                    selectedValue=""
                ></core-drop-down>
                <div class="col-lg-4">
                    <input type="text" :placeholder="$t('services.inventory.search')" />
                </div>
            </div>
        </div>
        <div class="col-lg-1 d-flex align-items-center p-0">
            <router-link to="export" class="action-link">{{ $t('services.inventory.export') }}</router-link>
        </div>
    </div>
</template>

<script>
import RollingStock from '@/services/hatsApi/RollingStock'

export default {
  data () {
    return {
      wagons: [],
      serviceTypes: []
    }
  },
  props: {
    rollingStockId: {
      type: Number | String,
      required: true
    }
  },
  async created () {
    try {
      let filters = [
        {
          property: 'rollingStockId',
          value: parseInt(this.rollingStockId)
        }
      ]
      const rollingStockWagonsResponse = await RollingStock.getRollingStockWagons(filters)
      if (rollingStockWagonsResponse.data.success) {
        this.wagons = rollingStockWagonsResponse.data.data
      }
    } catch (error) {
      console.error(error)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inventory/booking/SearchBar.vue